<template>
  <div class="common">
    <!-- 搜索表单 -->
    <search-form :formConfig="formConfig" :source="searchData" @handleSearchJsf="handleSearchJsf"
      @handleSearchCst="handleSearchCst" @handleSearchKlf="handleSearchKlf" @handleSearchZff="handleSearchZff"
      @search="search">
      <template slot="btns" v-if="tabType == 'pendingReceipt'">
        <a-button @click="cancel" class="search-btn-item btn-blue-line"
          :disabled="selectedRowKeys.length == 0">撤销</a-button>
      </template>
      <template slot="btns" v-if="tabType == 'goldpayPendingReceipt'">
        <a-button @click="cancelPay" class="search-btn-item btn-blue-line"
          :disabled="selectedRowKeys.length == 0">撤销</a-button>
      </template>
      <template slot="btns" v-if="tabType == 'goldSearch'">
        <a-button class="search-btn-item btn-blue-line" :disabled="tableData.length == 0"
          @click="goldListExport">查询结果导出</a-button>
        <a-button class="search-btn-item btn-blue-line" :disabled="tableData.length == 0"
          @click="goldPayRecordExport">追溯记录导出</a-button>
      </template>
      <template slot="btns" v-if="tabType == 'goldcheckPending'">
        <a-button @click="singIn" :loading="checkLoad" class="search-btn-item" type="primary"
          :disabled="!selectedRowKeys.length || (!isPromiseGoldcheck && selectNeedSign())">签收</a-button>
        <a-button @click="singOut" :loading="checkLoadCancel" class="search-btn-item btn-blue-line"
          :disabled="!selectedRowKeys.length || (!isPromiseGoldcheck && selectNeedSign())">拒绝</a-button>
      </template>
    </search-form>

    <div v-if="tabType == 'goldcheckPending'">
      <a-checkbox v-model="isPromiseGoldcheck" style="margin:0 0 16px 0;">已阅读并同意所勾选的《转让协议》</a-checkbox>
    </div>

    <!-- 祺信支付相关 -->
    <div v-if="tabType == 'goldpay'" style="background:#fff;padding-top:16px;">
      <div class="spaceLeft" style="margin:0 0 16px 16px;">
        <a-radio-group name="radioGroup" v-model="payRaio" :default-value="payRaio">
          <a-radio value="circle">圈子</a-radio>
          <a-radio value="typing">键入</a-radio>
        </a-radio-group>
        <div class="spaceLeft">
          <label><span class="text-color-orange">*</span>接收方：</label>
          <div style="width:240px;margin-right:16px;">
            <a-input v-model="recPersonText" v-if="payRaio == 'typing'"></a-input>
            <select-search v-else v-model="recPersonInfo" :searchSource="true" :dataSource="recPersonList"
              headNameFirst="客户名称" headNameSecond="社会信用代码" valuePorp="customerOrgCode" labelPorp="customerName"
              @handleSearch="getCircleList"></select-search>
          </div>
          <a-button @click="showModalPay" :disabled="!payDisabled" class="search-btn-item" type="primary">支付</a-button>
        </div>
      </div>
      <a-checkbox v-model="isPromise" style="margin:0 0 16px 16px;">已阅读并同意所勾选的《转让协议》</a-checkbox>
    </div>

    <div>
      <div class="table-check-bar" v-if="selectedRows.length">
        已选择：
        <span class="text-color-blue">{{ selectedRows.length }} 条</span>
        {{ selectName || "祺信面额" }}：
        <span class="text-color-orange" v-if="tabType == 'sellerExpired'">{{ totalPayable(selectedRows) }} 元</span>
        <span class="text-color-orange" v-else>{{ totalPayable(selectedRows, selectProp) | splitK }} 元</span>
      </div>
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" @change="handleTableChange" bordered :locale="{ emptyText: '暂无数据' }"
        :row-selection="tableSelect">
        <template slot="guarantorName" slot-scope="text,record">
          <span v-if="record.guarantorName">
            {{ record.guarantorName }}
          </span>
          <span v-else>--</span>
        </template>
        <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>
        <template slot="gldBal" slot-scope="text">{{ text | splitK }}</template>
        <template slot="exDay" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
        <template slot="residueDays" slot-scope="text, record">{{ getDaysFormNow(record.exDay) }}</template>
        <template slot="estbDay" slot-scope="text,record">{{ record.estbDay | dateFormat('YYYY-mm-dd') }}</template>
        <template slot="signToacptDay" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
        <template slot="createTime" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
        <template slot="canBeModified" slot-scope="text">{{ text | gbCbmTrans }}</template>
        <template slot="gldStCd" slot-scope="text,record">
          <div class="spaceCenter">
            {{ text | GbGldStCdTrans }}
            <a-popover title="拒绝原因">
              <template slot="content">
                <div style="color:#666;max-width:200px;">{{ record.opin || "" }}</div>
              </template>
              <!-- 平台审核已拒绝、资方审批拒绝 -->
              <svg v-if="record.gldStCd == 4 && record.opin" class="payable-icon" aria-hidden="true">
                <use xlink:href="#gold-icon-tishi"></use>
              </svg>
            </a-popover>
          </div>
        </template>
        <template slot="openType" slot-scope="text,record">
          <div class="spaceCenter">
            <div v-if="record.openType">
              <span v-if="record.openType == 0">无</span>
              <span v-if="record.openType == 1">有</span>
            </div>
            <span v-else>--</span>
          </div>
        </template>
        <template slot="odueCd" slot-scope="text">{{ text == 1 ? "是" : "否" }}</template>
        toPageDetail
        <template slot="payAmt" slot-scope="text,record">
          <a-input v-model="record.payAmt" @blur="payAmtCheck(record)" class="text-center" />
          <p v-if="!record.payAmtCheck" class="text-color-orange text-center">输入金额不能大于{{ record.gldBal | splitK }}元</p>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
          <a v-if="tabType === 'sellerSigned'" @click="getPdf(record)">凭证</a>
        </template>
        <template slot="operationChange" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
          <a v-if="record.canBeModified == 1 && checkInTime(record)" @click="toChange(record)">变更</a>
          <a @click="getPdf(record)">凭证</a>
        </template>
        <template slot="operationPay" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
          <a v-show="selectedRowKeys.indexOf(record.id) > -1" @click="toTransferContract(record)">转让协议</a>
        </template>
        <!-- 祺信签收、同意时的操作 -->
        <template slot="operationCheck" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
          <a v-show="record.oriGldId != 0" @click="toTransferContractCheck(record.gldId)">转让协议</a>
        </template>
      </a-table>
      <div :class="{ 'table-total': pagination.total > 0, 'table-total-none': pagination.total == 0 }">
        共有记录：
        <span class="text-color-blue">{{ pagination.total }} 条</span>{{ totalName }}：
        <span class="text-color-orange" v-if="tabType == 'sellerExpired'">{{ totalPayable(tableData) }} 元</span>
        <span class="text-color-orange" v-else>{{ totalPayable(tableData) | splitK }} 元</span>
      </div>
    </div>

    <!-- 弹窗 -->
    <a-modal width="400px" title="祺信开立-撤销" :visible="modalShow" :maskClosable="false" :footer="null"
      @cancel="modalCancel">
      <goldPasswordModal :confirmData.sync="confirmTableData" @ok="modalOk" @cancel="modalCancel"></goldPasswordModal>
    </a-modal>
    <a-modal width="400px" title="祺信支付-撤销" :visible="modalShowPayCancel" :maskClosable="false" :footer="null"
      @cancel="modalCancel">
      <goldPasswordModal :confirmData.sync="confirmTableData" @ok="modalOkPayCancel" @cancel="modalCancel">
      </goldPasswordModal>
    </a-modal>

    <a-modal width="400px" title="祺信支付" :visible="modalShowPay" :maskClosable="false" :footer="null"
      @cancel="modalCancelPay">
      <goldPayModal v-if="modalShowPay" :modalData.sync="modalPayData" @ok="modalOkPay" @cancel="modalCancelPay">
      </goldPayModal>
    </a-modal>

    <a-modal :bodyStyle="{ height: '540px', overflow: 'auto' }" width="80%" title="祺信转让协议"
      :visible="showTransferContract" :footer="null" @cancel="showTransferContract = false; transferContractHtml = ''">
      <div v-html="transferContractHtml"></div>
    </a-modal>

    <a-modal width="400px" title="祺信签收-同意" :visible="modalShowSign" :maskClosable="false" :footer="null"
      @cancel="modalCancel">
      <goldPasswordModal v-if="confirmTableDataSign" :confirmData.sync="confirmTableDataSign" @ok="modalOkSign"
        @cancel="modalCancel"></goldPasswordModal>
    </a-modal>
    <a-modal width="400px" title="祺信签收-拒绝" :visible="modalShowSignOut" :maskClosable="false" :footer="null"
      @cancel="modalCancel">
      <goldPasswordModal v-if="confirmTableDataSign" :confirmData.sync="confirmTableDataSign" @ok="modalOkSignOut"
        @cancel="modalCancel"></goldPasswordModal>
    </a-modal>
    <!-- 祺信变更 -->
    <changeModal ref="changeModal" :info.sync="curItem" :paramValue.sync="paramValue" @success="refresh" />
    <!-- 凭证预览 -->
    <pdfView ref="pdfView"></pdfView>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"

import { selectTenant } from "@/api/login.js"
import { findGoldEstbOrRcPtyOrPypt, queryGoldPageApi, pagingCircleList, queryGoldTransferContract, goldPayWithdraw, goldbuyerWithdraw, queryGoldPageExport, goldPayRecordExport } from "@/api/gold.js"
import { signIn, signOut } from "@/api/goldseller.js"
import { getparamValue } from "@/api/payable.js";

import confirmPasswordModal from "@/components/table-find-rcvb/confirm-password-modal"
import goldPayModal from "@/components/gold-page/gold-pay-modal"
import goldPasswordModal from "./confirm-password-modal"
import changeModal from "./change-modal"
import pdfView from "./pdf-view.vue"
export default {
  name: "tableFindRcvb",
  props: {
    fromPath: {
      type: [String],
      required: false,
      default: function () {
        return '';
      },
    },
    gldStCds: {
      type: [String, Number],
      required: false,
      default: function () {
        return '';
      },
    },
    oriGldId: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    gldBal: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    toBeGldPaid: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    rcPty: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    rcPtys: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    estb: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    pypt: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    pypts: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    isGldPay: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    isGldLend: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    isGldEx: {
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      },
    },
    exDayEnd: {
      type: String,
      required: false,
      default: function () {
        return "";
      },
    },
    exDayStart: {
      type: String,
      required: false,
      default: function () {
        return "";
      },
    },
    formType: {
      type: [String],
      required: false,
      default: function () {
        return "issue"; //所属页面的类别 issue:开立方管理-信诺开立、goldenbill：开立方管理-信诺查询
      }
    },
    tabType: {
      type: [String],
      required: false,
      default: function () {
        return ""; //所属tab的分类
      }
    },
    fromTypeRouter: {
      type: [String],
      required: false,
      default: function () {
        return "1"; //祺信详情参数
      }
    },
    goldStatusOptions: {
      type: Array,
      required: false,
      default: function () {
        return []; //所属tab的祺信状态选项集
      }
    },
    totalName: {
      type: [String],
      required: false,
      default: function () {
        return "祺信面额";
      }
    },
    totalProp: {
      type: [String],
      required: false,
      default: function () {
        return "gldAmt";
      }
    },
    selectName: {
      type: [String],
      required: false,
      default: function () {
        return "祺信面额";
      }
    },
    selectProp: {
      type: [String],
      required: false,
      default: function () {
        return "gldBal";
      }
    },
    columnsSource: {
      type: [Array],
      required: false,
      default: function () {
        return null;
      }
    },
    formSource: {
      type: [Array],
      required: false,
      default: function () {
        return null;
      }
    },
    btns: {
      type: [Array],
      default() {
        return [];
      }
    },
    pageType: {
      type: String
    }
  },
  data() {
    return {
      paramValue: null,
      searchData: {
        estbDay: [],
        signToacptDay: [],
        gldId: "",
        exDay: [],
        estbDayZf: [],
        estbDaySq: [],
        receiver: "",
        canBeModified: "",
        tenantId: "",
        gldStCd: "",
        odueCd: "",
        estb: {},
        pypt: {},
        oriGldId: "",
        checkStatus: ""
      },
      formConfig: [
        {
          prop: "estbDay",
          label: "开立日期",
          type: "dateRange"
        },
        {
          prop: "signToacptDay",
          label: "签收日期",
          type: "dateRange"
        },
        {
          prop: "gldId",
          type: "input",
          label: "祺信编号",
        },
        {
          prop: "receiver",
          type: "selectSearch",
          label: "接收方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchJsf",
        },
        {
          prop: "estb",
          type: "selectSearch",
          label: "开立方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchKlf",
        },
        {
          prop: "pypt",
          type: "selectSearch",
          label: "支付方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchZff",
        },
        {
          prop: "exDay",
          type: "dateRange",
          label: "到期日期",
        },
        {
          prop: "tenantId",
          type: "selectSearch",
          label: "保理商",
          option: [],
          searchSource: true,
          valuePorp: "tenantId",
          labelPorp: "tenantName",
          normal: true,
          searchHandle: "handleSearchCst",
        },
        {
          prop: "canBeModified",
          type: "select",
          label: "变更状态",
          option: this.dict.modifiedStatus,
          defaultProps: {
            value: "value",
            label: "name"
          },
        },
        {
          prop: "odueCd",
          type: "select",
          label: "是否逾期",
          option: this.dict.yesOrNo,
          defaultProps: {
            value: "value",
            label: "name"
          }
        },
        {
          prop: "gldStCd",
          type: "select",
          label: "祺信状态",
          option: this.goldStatusOptions,
          defaultProps: {
            value: "value",
            label: "name"
          }
        },
        {
          prop: "checkStatus",
          type: "select",
          label: "状态",
          option: [{ name: "已同意", value: "1" }, { name: "已拒绝", value: "2" }],
          defaultProps: {
            value: "value",
            label: "name"
          }
        },
        {
          prop: "oriGldId",
          type: "input",
          label: "上级祺信"
        },
        {
          prop: "estbDayZf",
          type: "dateRange",
          label: "支付日期",
        },
        {
          prop: "estbDaySq",
          type: "dateRange",
          label: "申请日期",
        },
      ],
      columns: [
        {
          title: "开立日期",
          width: "100px",
          sorter: true,
          dataIndex: "estbDay",
          scopedSlots: { customRender: "estbDay" },

        },
        {
          title: "支付日期",
          sorter: true,
          width: "100px",
          dataIndex: "estbDay",
          scopedSlots: { customRender: "estbDay" },
        },
        {
          title: "签收日期",
          sorter: true,
          width: "100px",
          dataIndex: "signToacptDay",
          scopedSlots: { customRender: "signToacptDay" },
        },
        {
          title: "申请日期",
          sorter: true,
          width: "100px",
          dataIndex: "createTime",
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "祺信编号",
          dataIndex: "gldId",
          width: "200px",
          ellipsis: true,
        },
        {
          title: "担保方",
          dataIndex: "guarantorName",
          scopedSlots: { customRender: "guarantorName" },
        },
        {
          title: "接收方",
          dataIndex: "rcPtyNm"
        },

        {
          title: "开立方",
          dataIndex: "estbNm"
        },
        {
          title: "支付方",
          dataIndex: "pyptNm"
        },
        {
          title: "祺信面额(元)",
          dataIndex: "gldAmt",
          scopedSlots: { customRender: "gldAmt" }
        },
        {
          title: "祺信余额(元)",
          dataIndex: "gldBal",
          scopedSlots: { customRender: "gldBal" }
        },

        {
          title: "到期日期",
          sorter: true,
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" },
        },
        {
          title: "剩余天数",
          sorter: true,
          dataIndex: "residueDays",
          scopedSlots: { customRender: "residueDays" },
        },
        {
          title: "上级祺信",
          dataIndex: "firstGld"
        },
        {
          title: "保理商",
          dataIndex: "tenantName",
        },

        {
          title: "待审批人",
          dataIndex: "toDoPeople",
          ellipsis: true
          // scopedSlots: { customRender: "canBeModified" },
        },
        {
          title: "变更状态",
          dataIndex: "canBeModified",
          scopedSlots: { customRender: "canBeModified" },
        },
        {
          title: "祺信状态",
          dataIndex: "gldStCd",
          scopedSlots: { customRender: "gldStCd" },
        },
        {
          title: "是否逾期",
          dataIndex: "odueCd",
          scopedSlots: { customRender: "odueCd" },
        },
        {
          title: "支付金额(元)",
          dataIndex: "payAmt",
          scopedSlots: { customRender: "payAmt" },
        },
        {
          title: "状态",
          dataIndex: "gldStCd",
          scopedSlots: { customRender: "gldStCd" },
        },
        {
          title: "当前审批人",
          dataIndex: "toDoPeople",
        },
        {
          title: "有无发票",
          dataIndex: "openType",
          width: 80,
          scopedSlots: { customRender: "openType" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
        {
          title: "转让协议",
          title2: "操作",
          dataIndex: "operationPay",
          scopedSlots: { customRender: "operationPay" },
        },
        {
          title: "祺信签收转让协议",
          title2: "操作",
          dataIndex: "operationCheck",
          scopedSlots: { customRender: "operationCheck" },
        },
        {
          title: "祺信变更",
          title2: "操作",
          dataIndex: "operationChange",
          scopedSlots: { customRender: "operationChange" },
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "",
        sortOrder: "",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showTotal: (total) => {
          return `共 ${total} 条`
        }
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      curItem: {},
      modalShow: false,
      confirmTableData: [],

      modalShowPay: false,
      modalPayData: null,
      isPromise: false,
      payRaio: "circle",
      recPersonInfo: {},
      recPersonText: "",
      recPersonList: [],

      showTransferContract: false,
      transferContractHtml: "",

      isPromiseGoldcheck: false,
      checkLoad: false,
      checkLoadCancel: false,

      modalShowSign: false,
      confirmTableDataSign: null,
      modalShowSignOut: false,
      modalShowPayCancel: false
    }
  },
  components: {
    confirmPasswordModal, goldPayModal, goldPasswordModal, changeModal, pdfView
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    }),
    tableSelect() {
      if (this.tabType == 'pendingReceipt' || this.tabType == 'goldcheckPending' || this.tabType == 'goldpayPendingReceipt') {
        return {
          selectedRowKeys: this.selectedRowKeys,
          selectedRows: this.selectedRows,
          onSelectAll: this.onSelectAll,
          onSelect: this.onSelect,
        }
      }
      else if (this.tabType == 'goldpay') {
        return {
          selectedRowKeys: this.selectedRowKeys,
          selectedRows: this.selectedRows,
          onSelectAll: this.onSelectAll,
          onSelect: this.onSelect,
          getCheckboxProps: record => ({
            props: {
              disabled: record.canBeModified == '3' // Column configuration not to be checked
            },
          }),
        }
      }
      return null;
    },
    payDisabled() {
      let res = false;
      if (this.payRaio == "circle") {
        res = this.recPersonInfo.key && this.isPromise == true;
      } else {
        res = this.recPersonText && this.isPromise == true;
      }
      return res;
    }

  },
  created() {
    this.getparamValues()
    //过滤搜索表单、表头展示
    if (this.columnsSource) {
      let resColumn = [];
      this.columnsSource.forEach(item => {
        for (let i = 0; i < this.columns.length; i++) {
          if (this.columns[i].title == item) {
            resColumn.push({
              ...this.columns[i],
              title: this.columns[i].title2 || this.columns[i].title, //针对不用的操作列表，title为区分字段，title2为显示字段
            });
            break;
          }
        }
      })
      this.columns = resColumn;
    }
    if (this.formSource) {
      let resForm = [];
      this.formSource.forEach(item => {
        for (let i = 0; i < this.formConfig.length; i++) {
          if (this.formConfig[i].label == item) {
            resForm.push(this.formConfig[i]);
            break;
          }
        }
      })
      this.formConfig = resForm;
    }
    if (this.tabType == "goldpay") {
      this.pagination.sortField = "exDay";
      this.pagination.sortOrder = "descend";
    }
    this.getTableData();
  },
  methods: {
    handleSearchJsf(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {};
      switch (this.tabType) {
        case "pendingReview":
        case "tobeConfirmed":
        case "pendingReceipt":
        case "signed":
        case "all":
          param = {
            oriGldId: 0,
            queryType: 0,
            estb: cstIds,
            pypt: cstIds,
            cstIds: cstIds,
          };
          break;
        case "goldSearch":
          param = {
            queryType: 0,
            oriGldId: 0,
            estb: cstIds,
            pypt: cstIds,
            cstIds: cstIds,
          };
          break;
        case "sellerPaid":
          param = {
            queryType: 3,
            pypt: cstIds,
            cstIds: cstIds,
          };
          break;
        case "sellerFinanced":
          param = {
            queryType: 3,
            pypt: cstIds,
            cstIds: cstIds,
            isGldLend: 'Y'
          };
          break;
        case "goldpayPendingReview":
        case "goldpayPendingReceipt":
        case "goldpaySigned":
        case "goldpayAll":
          param = {
            queryType: 3,
            cstIds: cstIds
          };
          break;
      }
      this.getDataList(value, param, cfg);
    },
    handleSearchKlf(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {};
      switch (this.tabType) {
        case "sellerSigned":
          param = {
            queryType: 1,
            rcPty: cstIds,
            cstIds: cstIds,
          };
          break;
        case "sellerPaid":
          param = {
            queryType: 1,
            pypt: cstIds,
            cstIds: cstIds,
            isGldLend: 'Y'
          };
          break;
        case "sellerFinanced":
          param = {
            queryType: 1,
            pypt: cstIds,
            cstIds: cstIds,
            isGldLend: 'Y'
          };
          break;
        case "sellerExpired":
          param = {
            queryType: 1,
            rcPty: cstIds,
            cstIds: cstIds,
            isGldEx: 'Y',
            exDayEnd: this.exDayEnd
          };
          break;
        case "goldpay":
          param = {
            exDayStart: this.exDayStart,
            queryType: 1,
            cstIds: cstIds
          };
          break;
        case "goldpayPendingReview":
        case "goldpayPendingReceipt":
        case "goldpaySigned":
        case "goldpayAll":
          param = {
            queryType: 1,
            cstIds: cstIds
          };
          break;
      }
      this.getDataList(value, param, cfg);
    },
    handleSearchZff(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {};
      switch (this.tabType) {
        case "sellerSigned":
          param = {
            queryType: 2,
            rcPty: cstIds,
            cstIds: cstIds,
          };
          break;
        case "sellerExpired":
          param = {
            queryType: 2,
            rcPty: cstIds,
            cstIds: cstIds,
            isGldEx: 'Y',
            exDayEnd: this.exDayEnd
          };
          break
      }
      this.getDataList(value, param, cfg);
    },
    getDataList(value, param = {}, cfg) { //下拉筛选
      const cstIds = this.userObj.cstIds.join(",");
      findGoldEstbOrRcPtyOrPypt({
        cstNm: value,
        pageNum: 1,
        pageSize: 10,
        gldStCds: this.gldStCds,
        oriGldId: param.oriGldId,
        estb: param.estb,
        pypt: param.pypt,
        pypts: this.pypts,
        isGldPay: this.isGldPay,
        isGldLend: param.isGldLend,
        queryType: param.queryType || 0,
        rcPty: param.rcPty,
        exDayEnd: param.exDayEnd,
        exDayStart: param.exDayStart,
        cstIds: cstIds
      }).then((res) => {
        const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
        if (res.data && res.data.grid) {
          this.formConfig[index].option = res.data.grid.list || [];
        } else {
          this.formConfig[index].option = []
        }
      })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSearchCst(value, data, cfg) {
      this.getDataListTenant(value, cfg);
    },
    getDataListTenant(value, cfg) { //下拉筛选
      selectTenant({
        tenantName: value,
        pageSize: 10,
        tenantName: value || "",
        pageNum: 1,
      }).then((res) => {
        const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
        if (res.data && res.data.grid) {
          this.formConfig[index].option = res.data.grid.list || [];
        } else {
          this.formConfig[index].option = []
        }
      })
        .catch((error) => {
          console.log(error);
        });
    },
    search(data) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    totalPayable(list, key) {
      if (this.tabType == "sellerExpired") {
        let sumObj = this.totalGold2(list);
        return this.utils.splitK(sumObj.toRcvpymtAmt) + "+" + this.utils.splitK(sumObj.toRcvpymtGldInt);
      }
      return list.reduce((acc, rec) => {
        return acc + (+rec[key || this.totalProp] || 0);
      }, 0);
    },
    totalGold2(rows) {
      let toRcvpymtAmt = 0;
      let toRcvpymtGldInt = 0;
      for (const item of rows) {
        if (item.toRcvpymtAmt) {
          toRcvpymtAmt += (+item.toRcvpymtAmt);
        }
        if (item.toRcvpymtGldInt) {
          toRcvpymtGldInt += (+item.toRcvpymtGldInt);
        }
      }
      return { toRcvpymtAmt, toRcvpymtGldInt };
    },
    handleTableChange(pagination, filters, sorter) { //表格排序回调
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      if (JSON.stringify(sorter) !== '{}') {
        this.pagination.sortField = sorter.field
        this.pagination.sortOrder = sorter.order
      }
      this.pagination.total = this.pagination.total || 0
      this.getTableData();
    },
    getTableData() {
      let params = {};
      params = {
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "residueDays" ? 'exDay' : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        estbDayStart: this.searchData.estbDay[0] || this.searchData.estbDayZf[0] || this.searchData.estbDaySq[0],
        estbDayEnd: this.searchData.estbDay[1] || this.searchData.estbDayZf[1] || this.searchData.estbDaySq[1],
        gldId: this.searchData.gldId,
        rcPty: this.rcPty ? this.rcPty : this.searchData.receiver.key,
        rcPtys: this.rcPtys ? this.rcPtys : this.searchData.receiver.key,
        tenantId: this.searchData.tenantId.key,
        canBeModified: this.searchData.canBeModified,
        exDayStart: this.searchData.exDay[0] || this.exDayStart,
        exDayEnd: this.searchData.exDay[1] || this.exDayEnd,
        signToacptDayStart: this.searchData.signToacptDay[0],
        signToacptDayEnd: this.searchData.signToacptDay[1],
        gldStCds: (this.searchData.checkStatus == 1 ? '1,6' : (this.searchData.checkStatus == 2 ? '3' : '')) || this.gldStCds,
        oriGldId: !this.utils.isUndefined(this.oriGldId) ? this.oriGldId : this.searchData.oriGldId,
        gldStCd: this.searchData.gldStCd,
        odueCd: this.searchData.odueCd,
        estb: this.estb || this.searchData.estb.key,
        pypt: this.pypt || this.searchData.pypt.key,
        pypts: this.pypts,
        isGldPay: this.isGldPay,
        isGldLend: this.isGldLend,
        isGldEx: this.isGldEx,
        gldBal: this.gldBal,
        toBeGldPaid: this.toBeGldPaid,
        pageType: this.pageType,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      this.loading = true;
      queryGoldPageApi(params)
        .then((res) => {
          this.pagination.total = res.data.grid.total;
          this.tableData = res.data.grid.list;
          // 判断是否祺信支付页面，如果是需要回显选中的支付金额数值
          if (this.tabType == "goldpay") {
            this.renderTablePayAmt();
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    cancel() {
      const self = this;
      this.$confirm({
        title: '撤销',
        content: "是否撤销所勾选的祺信？",
        onOk() {
          self.showModal();
        },
        onCancel() {
        },

      })
    },
    cancelPay() {
      const self = this;
      this.$confirm({
        title: '撤销',
        content: "是否撤销所勾选的祺信？",
        onOk() {
          self.showModalPayCancel();
        },
        onCancel() {
        },

      })
    },
    //表格选择回调
    onSelect(selectedRows, checked) {
      if (checked) {
        this.selectedRowKeys.push(selectedRows.id);
        this.selectedRows.push(selectedRows);
      } else {
        let index = this.selectedRowKeys.indexOf(selectedRows.id);
        this.selectedRowKeys.splice(index, 1);
        this.selectedRows.splice(index, 1);
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        for (let i = 0; i < selectedRows.length; i++) {
          if (this.selectedRowKeys.indexOf(selectedRows[i].id) == -1) {
            this.selectedRowKeys.push(selectedRows[i].id);
            this.selectedRows.push(selectedRows[i]);
          }
        }
      } else {
        for (let i = 0; i < changeRows.length; i++) {
          let index = this.selectedRowKeys.indexOf(changeRows[i].id);
          if (index > -1) {
            this.selectedRowKeys.splice(index, 1);
            this.selectedRows.splice(index, 1);
          }
        }
      }
    },
    renderTablePayAmt() {
      this.tableData.forEach((i, idx) => {
        let selectIdx = this.selectedRowKeys.indexOf(i.id);
        let payAmt = selectIdx > -1 ? this.selectedRows[selectIdx].payAmt : 0;
        this.$set(this.tableData[idx], 'payAmt', payAmt);
        this.$set(this.tableData[idx], 'payAmtCheck', true);
      })
    },
    payAmtCheck(item) { //校验支付金额输入
      item.payAmt = this.utils.clearNoNum(item.payAmt);
      item.payAmtCheck = item.payAmt <= item.gldBal;
    },
    getCircleList(value) {
      this.pagingCircleList(value);
    },
    pagingCircleList(value) { //下拉筛选
      pagingCircleList({
        pageSize: 10,
        customerName: value || "",
        pageNum: 1,
      }).then((res) => {
        this.recPersonList = res.data.grid.list;
      })
        .catch((error) => {
          console.log(error);
        });
    },
    showModal(text, record) {
      this.confirmTableData = this.utils.deepClone(this.selectedRows);
      this.modalShow = true;
    },
    modalOk(e) {
      let param = {
        gldIds: this.confirmTableData.map(i => i.gldId).join(","),
        txnPwd: e.txnPwd
      }
      goldbuyerWithdraw(param).then(res => {
        this.$message.success("撤销成功");
        this.modalCancel();
        this.refresh();
      })
    },
    showModalPayCancel() {
      this.confirmTableData = this.utils.deepClone(this.selectedRows);
      this.modalShowPayCancel = true;
    },
    modalOkPayCancel(e) {
      let param = {
        gldIds: this.confirmTableData.map(i => i.gldId).join(","),
        txnPwd: e.txnPwd
      }
      goldPayWithdraw(param).then(res => {
        this.$message.success("撤销成功");
        this.modalCancel();
        this.refresh();
      })

    },
    modalCancel(e) {
      this.modalShowSignOut = false;
      this.modalShowSign = false;
      this.confirmTableDataSign = null;
      this.modalShowPayCancel = false;
      this.modalShow = false;
      this.refresh();
    },
    showModalPay(text, record) {
      if (this.selectedRows.find(i => i.payAmt <= 0)) {
        this.$message.error("所勾选祺信的支付金额均需大于0");
        return;
      }

      let recPersonInfo = {};
      if (this.payRaio == "circle") {
        recPersonInfo = {
          cstNm: this.recPersonInfo.label,
          recPersonSrc: '0',
          orgCode: this.recPersonInfo.key,
        }
      } else {
        recPersonInfo = {
          cstNm: this.recPersonText,
          recPersonSrc: '1'
        }
      }
      let list = [];
      this.selectedRows.forEach(item => {
        list.push({
          gldId: item.gldId,
          payAmt: item.payAmt,
          canTradeGldBal: item.gldBal,
          preNewGldId: item.preNewGldId
        })
      })
      this.modalPayData = {
        list: list,
        recPersonInfo: recPersonInfo
      };
      this.modalShowPay = true;
    },
    modalOkPay(e) {
      this.$message.success("支付申请提交成功，等待审核");
      this.modalCancelPay();
      this.refresh();
    },
    modalCancelPay(e) {
      this.modalShowPay = false;
    },
    toPageDetail(data) {
      if (data.fncJrnlId) {
        this.MENUAPI.goToOneTab({
          path: "circulation/borrow/details/" + data.fncJrnlId,
          query: {
            fromPath: this.fromPath,
            isGldLend: this.isGldLend //判断是否已融资
          }
        });
      }
      else {
        let way = "";
        switch (this.formType) {
          case "issue": way = "buyer"; break;
          case "goldenbill": way = "buyer"; break;
          case "seller": way = "seller"; break;
          default: way = "buyer"; break;
        }
        this.MENUAPI.goToOneTab({
          path: "bill-payment/payment/detail/" + way + "/" + data.gldId + "/" + this.fromTypeRouter,

          query: {
            fromPath: this.fromPath
          }
        });
      }
    },
    toTransferContract(data) {
      const rcPtyNm = (this.payRaio == "circle" ? this.recPersonInfo.label : this.recPersonText);
      if (!rcPtyNm) {
        this.$message.warn("接收方不能为空");
        return;
      }
      const params = {
        manualCreate: 1,
        gldId: data.preNewGldId,
        oriGldId: data.gldId,
        pyptNm: data.rcPtyNm,
        rcPtyNm: rcPtyNm,
        estbNm: data.estbNm,
        estbDay: data.estbDay,
        exDay: data.exDay,
        rcPty: data.rcPty,
        gldAmt: data.payAmt,
      };
      queryGoldTransferContract(params, true)
        .then((res) => {
          this.transferContractHtml = res.data.contractContent;
          this.showTransferContract = true;
        })
        .catch((err) => {
          console.log(err);
        })
    },
    toTransferContractCheck(gldId) {
      queryGoldTransferContract({ gldId }, true)
        .then((res) => {
          this.transferContractHtml = res.data.contractContent;
          this.showTransferContract = true;
        })
        .catch((err) => {
          console.log(err);
        })
    },
    // 判断所勾选的祺信是否需要查看转让协议
    selectNeedSign() {
      let item = this.selectedRows.find(i => i.oriGldId != 0);
      if (item) {
        return true;
      }
      return false;
    },
    singIn() {
      let self = this;
      this.$confirm({
        title: '签收',
        content: "是否确定签收祺信？",
        onOk() {
          self.confirmTableDataSign = self.utils.deepClone(self.selectedRows);
          self.modalShowSign = true;
        },
        onCancel() {
          self.modalShowSign = false;
          self.confirmTableDataSign = null;
        },
      })
    },
    singOut() {
      let self = this;
      this.$confirm({
        title: '拒绝签收',
        content: "是否拒绝所选祺信？",
        onOk() {
          self.confirmTableDataSign = self.utils.deepClone(self.selectedRows);
          self.modalShowSignOut = true;
        },
        onCancel() {
          self.modalShowSignOut = false;
          self.confirmTableDataSign = null;
        },
      })
    },
    modalOkSign(data) {
      let param = {
        txnPwd: data.txnPwd,
        gldIds: this.confirmTableDataSign.map(i => i.gldId).join(",")
      }
      signIn(param).then(res => {
        this.$message.success("祺信签收成功");
        this.modalCancel();
      })
    },
    modalOkSignOut(data) {
      let param = {
        txnPwd: data.txnPwd,
        gldIds: this.confirmTableDataSign.map(i => i.gldId).join(",")
      }
      signOut(param).then(res => {
        this.$message.success("祺信拒绝签收成功");
        this.modalCancel();
      })
    },
    getparamValues() {
      getparamValue().then(res => {
        this.paramValue = Number(res.data.paramValue)
        // this.overdueRate = res.data.overdueRate;
      });
    },
    checkInTime(item) {
      // 前11日起，不可再变更
      return (new Date()).getTime() < ((new Date(item.exDay)).getTime() - this.paramValue * 24 * 60 * 60 * 1000);
    },
    toChange(data) {
      this.curItem = data;
      this.$refs.changeModal.open(data);

    },
    // 计算距离到期日还有几天
    getDaysFormNow(date) {
      let systemDate = window.sessionStorage.getItem("systemDate") || "";
      let end = new Date(date).getTime();
      let now = new Date(systemDate).getTime();
      if (end > now) {
        return Math.ceil((end - now) / (1000 * 60 * 60 * 24))
      } else {
        return 0
      }
    },
    // 祺信查询记录导出
    goldListExport() {
      let params = {
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "residueDays" ? 'exDay' : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        estbDayStart: this.searchData.estbDay[0] || this.searchData.estbDayZf[0] || this.searchData.estbDaySq[0],
        estbDayEnd: this.searchData.estbDay[1] || this.searchData.estbDayZf[1] || this.searchData.estbDaySq[1],
        gldId: this.searchData.gldId,
        rcPty: this.rcPty ? this.rcPty : this.searchData.receiver.key,
        rcPtys: this.rcPtys ? this.rcPtys : this.searchData.receiver.key,
        canBeModified: this.searchData.canBeModified,
        exDayStart: this.searchData.exDay[0] || this.exDayStart,
        exDayEnd: this.searchData.exDay[1] || this.exDayEnd,
        gldStCds: (this.searchData.checkStatus == 1 ? '1,6' : (this.searchData.checkStatus == 2 ? '3' : '')) || this.gldStCds,
        gldStCd: this.searchData.gldStCd,
        odueCd: this.searchData.odueCd,
        estb: this.estb || this.searchData.estb.key,
        pypt: this.pypt || this.searchData.pypt.key,
        pypts: this.pypts,
        pageType: this.pageType,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      queryGoldPageExport(params).then(res => {
        this.utils.fileDownload(res, `查询记录_${new Date().getTime()}.xls`);
      }).catch(e => {
        this.$message.error("导出失败");
      })
    },
    // 追溯记录导出
    goldPayRecordExport() {
      let params = {
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "residueDays" ? 'exDay' : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        estbDayStart: this.searchData.estbDay[0] || this.searchData.estbDayZf[0] || this.searchData.estbDaySq[0],
        estbDayEnd: this.searchData.estbDay[1] || this.searchData.estbDayZf[1] || this.searchData.estbDaySq[1],
        gldId: this.searchData.gldId,
        rcPty: this.rcPty ? this.rcPty : this.searchData.receiver.key,
        rcPtys: this.rcPtys ? this.rcPtys : this.searchData.receiver.key,
        canBeModified: this.searchData.canBeModified,
        exDayStart: this.searchData.exDay[0] || this.exDayStart,
        exDayEnd: this.searchData.exDay[1] || this.exDayEnd,
        gldStCds: (this.searchData.checkStatus == 1 ? '1,6' : (this.searchData.checkStatus == 2 ? '3' : '')) || this.gldStCds,
        gldStCd: this.searchData.gldStCd,
        odueCd: this.searchData.odueCd,
        estb: this.estb || this.searchData.estb.key,
        pypt: this.pypt || this.searchData.pypt.key,
        pypts: this.pypts,
        pageType: this.pageType,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      goldPayRecordExport(params).then(res => {
        this.utils.fileDownload(res, `追溯记录_${new Date().getTime()}.xls`);
      }).catch(e => {
        this.$message.error("导出失败");
      })
    },
    refresh() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.modalPayData = {};
      this.isPromise = false;
      this.search();
      this.$store.dispatch("home/getMessageCount");
    },
    // pdf 预览
    getPdf(row) {
      this.$refs.pdfView.open({
        type: row.gldLevel == 1 ? 8 : 9,
        expdId: row.gldId,
      })
    }
  },
  watch: {
    tableData: {
      deep: true,
      handler(newVal, oldVal) {
        this.tableData.forEach((i, idx) => {
          // 监听祺信支付页面的支付金额的输入改变
          if (this.tabType == "goldpay") {
            let selectIdx = this.selectedRowKeys.indexOf(i.id);
            if (selectIdx > -1) {
              let payAmt = i.payAmt || 0;
              this.$set(this.selectedRows[selectIdx], 'payAmt', payAmt);
              this.$set(this.selectedRows[selectIdx], 'payAmtCheck', true);
            }
          }
        })
      }
    }
  }
};
</script>
<style scoped>
.common-question {
  color: #ccc;
  font-size: 13px;
  margin-right: 10px;
}

.text-center {
  text-align: center;
}

.payable-icon {
  width: 17px;
  height: 17px;
  margin-left: 4px;
  position: relative;
  top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-page.vue